/***
 * Configuration for Bills Routes
 *
 * Bill Routes
 ***/

/* ----- Views ----- */

// Bill
import Bills from "@/pages/Bills/Bills";

/* ----- ----- ----- ----- ----- ----- ----- */

const billRoutes = [
    {
        path: 'billing',
        redirect: 'billing/contract'
    },
    {
        path: 'billing/contract',
        name: 'Billing Contracts',
        component: Bills,
        meta: {
            route: {
                label: 'Facturation contrats'
            }
        },
    },
    {
        path: 'billing/intervention',
        name: 'Billing Interventions',
        component: Bills,
        meta: {
            route: {
                label: 'Facturation interventions'
            }
        },
    },
]

const routes = [...billRoutes]
export default routes